import React from 'react';

import type { IIcon } from '../types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 30, className, onClick }, ref) {
  return (
    <svg ref={ref} viewBox='0 0 512 512' onClick={onClick} width={size} height={size} className={className}>
      <path
        d='M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z'
        fill='#e2e5e7'
        data-original='#e2e5e7'
      />
      <path d='M384,128h96L352,0v96C352,113.6,366.4,128,384,128z' fill='#b0b7bd' data-original='#b0b7bd' />
      <polygon points='480,224 384,128 480,128 ' fill='#cad1d8' data-original='#cad1d8' />
      <path
        d='M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16  V416z'
        fill='#5b2460'
        data-original='#f15642'
      />
      <g xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M88.368,384c-4.096-2.304-6.656-6.912-4.096-12.288l36.72-71.744c3.456-6.784,12.656-7.04,15.856,0   l36.08,71.744c5.248,9.984-10.24,17.904-14.848,7.936l-5.632-11.248h-47.2l-5.52,11.248C97.712,384,92.992,384.912,88.368,384z    M143.392,351.52l-14.464-31.616l-15.744,31.616H143.392z'
          fill='#fff'
          data-original='#fff'
        />
        <path
          d='M189.184,384c-4.096-2.304-6.656-6.912-4.096-12.288l36.704-71.744   c3.456-6.784,12.672-7.04,15.872,0l36.064,71.744c5.248,9.984-10.24,17.904-14.832,7.936l-5.648-11.248h-47.2l-5.504,11.248   C198.512,384,193.776,384.912,189.184,384z M244.192,351.52l-14.448-31.616l-15.728,31.616H244.192z'
          fill='#fff'
          data-original='#fff'
        />
        <path
          d='M282.416,339.088c0-24.688,15.488-45.904,44.912-45.904c11.136,0,19.952,3.312,29.296,11.376   c3.456,3.184,3.84,8.832,0.384,12.4c-3.456,3.056-8.704,2.688-11.76-0.368c-5.248-5.504-10.624-7.024-17.92-7.024   c-19.696,0-29.168,13.936-29.168,29.536c0,15.872,9.344,30.464,29.168,30.464c7.296,0,14.08-2.96,19.952-8.192   c3.968-3.072,9.472-1.552,11.776,1.536c2.048,2.816,3.056,7.536-1.408,12.016c-8.96,8.336-19.696,9.984-30.336,9.984   C296.368,384.912,282.416,363.792,282.416,339.088z'
          fill='#fff'
          data-original='#fff'
        />
      </g>
      <path d='M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z' fill='#cad1d8' data-original='#cad1d8' />
    </svg>
  );
});

export default React.memo(Icon);
